<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <mat-card appearance="outlined">
    <mat-card-title>Role</mat-card-title>
    <div class="form-container">
      <ng-template formHost></ng-template>
    </div>
    <div class="inline-spacer"></div>
    <button (click)="onSave()" color="primary" mat-raised-button>Save</button>
  </mat-card>

  <div class="spacer"></div>

  <app-profile-role-manager *ngIf="roleId" [id]="roleId"></app-profile-role-manager>
</page-content>
